import { createAction } from 'typesafe-actions';

import { AttributesColors, BlockingAttributesI } from './job.types';

export const jobActions = {
  setFilterInfo: createAction('planogramFilter/SET_FILTER_INFO')<string>(),
  setFilter: createAction('planogramFilter/SET_FILTER')<string[]>(),
  clearFilters: createAction('planogramFilter/CLEAR_FILTERS')<void>(),
  setInitialJob: createAction('user/SET_INITIAL_JOB')<void>(),
  setBlockingAttributes: createAction('blockingFilter/SET_FILTER_ATTRIBUTES')<BlockingAttributesI>(),
  setBlockingColorAttributes: createAction('blockingFilter/SET_FILTER_COLOR_ATTRIBUTES')<AttributesColors>(),
};
